/*
const track = document.querySelector(".marquee-track");
const container = document.querySelector(".marquee");
const logos = Array.from(track.children);
const gap = 30;

// Calcular ancho total de los logos originales + gaps
const logosWidth = logos.reduce((acc, logo) => acc + logo.offsetWidth, 0) + gap * (logos.length - 1);

// Calcular cuántas veces duplicar los logos para cubrir al menos 2 veces el ancho del contenedor
const containerWidth = container.offsetWidth;
let repeatCount = Math.ceil((containerWidth * 2) / logosWidth);

// Duplicar los logos según el repeatCount
for (let i = 0; i < repeatCount; i++) {
  logos.forEach(logo => track.appendChild(logo.cloneNode(true)));
}

// Total width después de duplicar
const totalWidth = track.scrollWidth / 2; // mitad original

// Animación GSAP con modifiers para loop infinito sin huecos
gsap.to(track, {
  x: `-=${totalWidth}`,
  duration: 30,
  ease: "linear",
  repeat: -1,
  modifiers: {
    x: gsap.utils.unitize(x => parseFloat(x) % totalWidth)
  }
});*/


function initMarquee(marqueeSelector, trackSelector, speedDesktop = 50, speedMobile = 100) {
  const marquee = document.querySelector(marqueeSelector);
  if (!marquee) return;

  const track = marquee.querySelector(trackSelector);
  if (!track) return;

  const logos = Array.from(track.children);
  const gap = 30;

  // Calcular ancho total de los logos originales + gaps
  const logosWidth = logos.reduce((acc, logo) => acc + logo.offsetWidth, 0) + gap * (logos.length - 1);

  // Calcular cuántas veces duplicar los logos para cubrir al menos 2 veces el ancho del contenedor
  const containerWidth = marquee.offsetWidth;
  let repeatCount = Math.ceil((containerWidth * 2) / logosWidth);

  // Duplicar los logos según repeatCount
  for (let i = 0; i < repeatCount; i++) {
    logos.forEach(logo => track.appendChild(logo.cloneNode(true)));
  }

  const totalWidth = track.scrollWidth / 2; // mitad original

  // Determinar velocidad según ancho de pantalla
  const isMobile = window.innerWidth <= 768; // breakpoint móvil
  const speed = isMobile ? speedMobile : speedDesktop;

  const duration = totalWidth / speed; // duración según velocidad

  // Animación GSAP con modifiers para loop infinito sin huecos
  gsap.to(track, {
    x: `-=${totalWidth}`,
    duration: duration,
    ease: "linear",
    repeat: -1,
    modifiers: {
      x: gsap.utils.unitize(x => parseFloat(x) % totalWidth)
    }
  });
}

// Inicializamos ambos carruseles con velocidad adaptativa
initMarquee(".marquee", ".marquee-track", 50, 80);   // primer carrusel
initMarquee(".marquee2", ".marquee-track2", 50, 80); // segundo carrusel

